<template>
  <span class="spinner-loader">
    <p class="jm-visually-hidden">Merci de patienter...</p>
  </span>
</template>

<script>
export default {
  name: 'SpinnerLoader'
}
</script>
<style lang="scss" scoped>
$border-bottom-color: rgba($white, 0.3);

.spinner-loader {
  width: 17px;
  height: 17px;
  border: 3px solid $white;
  border-bottom-color: $border-bottom-color;
  border-radius: 50%;
  display: inline-block;
  animation: rotation-spinner 1s linear infinite;
}

@keyframes rotation-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
